"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = require("styled-components");
const tokens = __importStar(require("@trp-rps-rps-shared-web/rps-shared-web-styles/build/rpsPrimaryTheme/tokens.js"));
exports.default = styled_components_1.createGlobalStyle `

@font-face {
    font-family: 'Nimbus Sans Light';
    src: url("data:font/woff;base64,${tokens.AssetFontNimbussansLightWoff}") format('woff'),
    url("data:font/woff2;base64,${tokens.AssetFontNimbussansLightWoff2}") format('woff2');
    font-stretch: normal;
    font-style: normal; 
    font-weight: normal;
}
@font-face {
    font-family: 'Nimbus Sans Regular';
    src: url("data:font/woff;base64,${tokens.AssetFontNimbussansRegularWoff2}") format('woff'),
    url("data:font/woff2;base64,${tokens.AssetFontNimbussansRegularWoff2}") format('woff2');
    font-stretch: normal;
    font-style: normal; 
    font-weight: normal;
}
@font-face {
    font-family: 'Nimbus Sans Italic';
    src: url("data:font/woff;base64,${tokens.AssetFontNimbussansItalicWoff2}") format('woff'),
    url("data:font/woff2;base64,${tokens.AssetFontNimbussansItalicWoff2}") format('woff2');
    font-stretch: normal;
    font-style: normal; 
    font-weight: normal;
}
@font-face {
    font-family: 'Nimbus Sans Bold';
    src: url("data:font/woff;base64,${tokens.AssetFontNimbussansBoldWoff2}") format('woff'),
    url("data:font/woff2;base64,${tokens.AssetFontNimbussansBoldWoff2}") format('woff2');
    font-stretch: normal;
    font-style: normal; 
    font-weight: normal;
}
@font-face {
    font-family: 'Nimbus Sans Black';
    src: url("data:font/woff;base64,${tokens.AssetFontNimbussansBlackWoff2}") format('woff'),
    url("data:font/woff2;base64,${tokens.AssetFontNimbussansBlackWoff2}") format('woff2');
    font-stretch: normal;
    font-style: normal; 
    font-weight: normal;
}
`;
//# sourceMappingURL=fonts.js.map